import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReduxStateType } from "redux-store/types";
import { getEducationInformationRes } from "core/http/service/personnelInformation/resTypes";
import { uniqueId } from "lodash";

interface InitialState {
  status: ReduxStateType;
  data: getEducationInformationRes[];
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: [
    {
      degreeName: "",
      specializedName: "",
      transOrganizationName: "",
      classificationName: "",
      formOfTrainingName: "",
      graduationYear: "",
      trainingOrgOtherName: "",
    },
  ],
};

const getEducationInformationSlice = createSlice({
  name: "getEducationInformation",
  initialState,
  reducers: {
    getEducationInformationStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getEducationInformationSuccess: (
      state,
      action: PayloadAction<getEducationInformationRes[]>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      const degrees = (action.payload ?? []).map((item) => ({
        ...item,
        files: (item.files ?? []).map((file) => ({
          ...file,
          id: uniqueId(),
        })),
      }));
      state.data = degrees;
    },
    getEducationInformationFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetEducationInformation: () => {
      return { ...initialState };
    },
  },
});

export const {
  getEducationInformationStart,
  getEducationInformationSuccess,
  getEducationInformationFailed,
  resetEducationInformation,
} = getEducationInformationSlice.actions;

export default getEducationInformationSlice.reducer;
